import React from "react";
import "./index.scss";
import FileConstants from "../../../FileConstants";
import TextConstants from "../../../TextConstants";
import LazyLoad from "react-lazyload";

const ALL3DStore = () => {
  return (
    <>
      <WebVersion />
      <MobileVersion />
    </>
  );
};
const { title, text } = TextConstants.ALL3D_STORE;
const WebVersion = () => {
  return (
    <div className="d-none d-lg-block">
      <div
        className="row justify-space-between our-product-offering"
        style={{ marginTop: 120 }}
      >
        <div className="col-lg-6 col-12 bg-img">
          <img
            className="section-img load-lazy"
            src={FileConstants.ALL3D_STORE}
            alt="Store"
          />
        </div>
        <div className="col-lg-6 col-12" style={{ paddingLeft: 50 }}>
          <h4 className="font graphik-medium f-18 w-500 black-2b">{title}</h4>
          <p className="font graphik-regular f-16 w-400 grey-light">{text}</p>
        </div>
      </div>
    </div>
  );
};

const MobileVersion = () => {
  return (
    <div className="d-lg-none">
      <div className="our-product-offering" style={{ marginTop: 48 }}>
        <div
          className="col-12 justify-in-center direction-flex coll"
          style={{ textAlign: "center" }}
        >
          <h4 className="font graphik-medium f-16 w-500 black-2b">{title}</h4>
          <p className="font graphik-regular f-14 w-400 grey-light">{text}</p>
        </div>
        <div className="col-12 bg-img justify-in-center">
          <img
            className="section-img load-lazy"
            src={FileConstants.ALL3D_STORE}
            alt="Store"
          />
        </div>
      </div>
    </div>
  );
};
export default ALL3DStore;
